export default __webpack_public_path__ + "static/media/payment-invoice.3a6dfc9b.svg";